import React from 'react';
import styles from './content.module.scss';
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";

const AboutContent: React.FC<any> = () => {
    return (
        <div className={styles.about}>
            <div className={styles.intro}>
                <div className={styles.image}>
                    <img src="/images/about.png" alt="درباره تکست نویس" />
                </div>
                <div className={styles.description}>
                    <div>
                        <h2>درباره تکست نویس</h2>
                        <p>
                            تکست نویس از سال ۲۰۰۹ فعالیت خود را آغاز کرد. هدف تکست نویس راحتی دسترسی خوانندگان برای خرید تکست و بیت می باشد همچنین شاعران و آهنگسازان عزیز می توانند با کمترین هزینه هنر خود را معرفی کنند.
                            جهت انجام پروژه های سفارشی با شماره درج شده تماس بگیرید.
                        </p>
                    </div>
                </div>
            </div>
            <Container className={styles.services + ' py-5'}>
                <h3>خدمات ما</h3>
                <div className="row">
                    <div className="col-lg-3 col-6 mb-4">
                        <Link to="/texts" className={styles.service}>
                            <i className="fa fa-file-alt" />
                            <span>فروش تکست رپ</span>
                        </Link>
                    </div>
                    <div className="col-lg-3 col-6 mb-4">
                    <Link to="/beats" className={styles.service}>
                        <i className="fa fa-compact-disc" />
                        <span>فروش بیت رپ و پاپ</span>
                    </Link>
                    </div>
                    <div className="col-lg-3 col-6 mb-4">
                    <Link to="/maquettes" className={styles.service}>
                        <i className="fa fa-music-alt" />
                        <span>فروش ماکت</span>
                    </Link>
                    </div>
                    <div className="col-lg-3 col-6 mb-4">
                    <Link to="/studios" className={styles.service}>
                        <i className="fa fa-microphone-alt" />
                        <span>معرفی استودیوهای برتر</span>
                    </Link>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default AboutContent;
